import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6f3b6368"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "description-header-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "description-header-content"
}, [/*#__PURE__*/_createElementVNode("span", null, "维护系统菜单。")], -1));
const _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_form_page = _resolveComponent("form-page");
  const _directive_permission = _resolveDirective("permission");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, {
    description: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", null, _toDisplayString(`${$data.edit ? '修改' : '增加'}权限菜单`), 1)]), _hoisted_2]),
    _: 1
  }, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_form_page, null, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formModel,
      "label-width": "120px",
      rules: $data.formRules,
      class: "normal-form",
      ref: "formRef"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "权限编码",
        prop: "permissionCode"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.permissionCode,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.formModel.permissionCode = $event),
          placeholder: "请输入权限编码"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "权限名称",
        prop: "permissionName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.permissionName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.formModel.permissionName = $event),
          placeholder: "请输入权限名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "排序序号",
        prop: "permissionIndex"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $data.formModel.permissionIndex,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formModel.permissionIndex = $event),
          min: 1,
          max: 99,
          precision: 0,
          "step-strictly": ""
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "权限类型",
        prop: "type"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.formModel.type,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formModel.type = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            label: "菜单"
          }), _createVNode(_component_el_radio, {
            label: "按钮"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "上级权限",
        prop: "parentId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_cascader, {
          options: $data.permissions,
          props: $data.permissionProps,
          clearable: "",
          modelValue: $data.formModel.parentId,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formModel.parentId = $event),
          style: {
            "width": "100%"
          }
        }, null, 8, ["options", "props", "modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "图标",
        prop: "icon"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formModel.icon,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.formModel.icon = $event),
          placeholder: "请输入图标编码"
        }, {
          append: _withCtx(() => [$data.formModel.icon && $data.formModel.icon.startsWith('http') ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "menu-image",
            src: $data.formModel.icon
          }, null, 8, _hoisted_3)) : (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            class: _normalizeClass(["iconfont", $data.formModel.icon]),
            size: "18px"
          }, null, 8, ["class"]))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: $options.submitForm
        }, {
          default: _withCtx(() => [_createTextVNode(" 保存 ")]),
          _: 1
        }, 8, ["onClick"])), [[_directive_permission, ['permission_add', 'permission_edit']]]), _createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = () => {
            this.$router.go(-1);
          })
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  })]);
}